import * as React from 'react'
import { IStageProps, IPoint } from 'app/types'
import Clock from 'app/comp/clock'
import StageCounter from 'app/comp/stage-counter'
import Hint from 'app/comp/hint'
import { range } from 'app/service/util'
import DocumentEventHandler from 'app/comp/document-event-handler'


const RAW_TEXT = `
This is the storm.
An impossible game.
Wake up and out of
light where it feels
of shame. Or, luck!
`


export default class extends React.Component<IStageProps, {
  grab?: IPoint
  p: IPoint
}> {

  constructor(props) {
    super(props)

    this.state = {
      grab: undefined,
      p: { x: 0, y: 0 },
    }
  }

  handleRelease = () => {
    this.setState({grab: undefined})
  }

  handleMouseMove = (event) => {
    const {
      grab
    } = this.state

    if (grab) {
      this.setState({p: {x: event.clientX - grab.x, y: event.clientY - grab.y}})
    }
  }

  handleGrab = (event) => {
    const rect = event.currentTarget.getBoundingClientRect()
    this.setState({grab: {x: event.clientX - rect.x, y: event.clientY - rect.y}})
  }

  onClickBlock(i: number, j: number) {
    if (i == 18 && j == 1) {
      this.props.onNext()
    }
  }

  getHintText(): string {
    const { p } = this.state

    if (p.x == 0 && p.y == 0) {
      return "That sure is a moving image."
    } else {
      return "That image looks like the perfect size. I wonder if they fit together."
    }
  }

  render() {
    const {
      p
    } = this.state

    const hasMoved = p.x + p.y > 0

    return (
      <div className="container">

        <Hint
          onAddTime={this.props.onAddTime}
          delay={1 * 60 * 1000}
          text={this.getHintText()}
        />

        <DocumentEventHandler
          onMouseUp={this.handleRelease}
          onMouseMove={this.handleMouseMove}
        />

        <StageCounter info={this.props.stageInfo} />

        <Clock time={this.props.time} />

        <pre
          style={{
            lineHeight: 1,
            fontSize: 24,
            fontFamily: 'Inconsolata, monospace'
          }}
          dangerouslySetInnerHTML={{ __html: RAW_TEXT }}
        />

        <svg
          onMouseDown={this.handleGrab}
          width="240"
          height="200"
          viewBox="0 0 240 200"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            position: hasMoved ? 'absolute' : 'static',
            top: p.y,
            left: p.x
          }}
        >

          {range(20).map(i => range(5).map(j =>
            <rect key={i + j * 20} x={i * 12} y={j * 24} width="12" height="24" fill={getColor(i, j)} onClick={() => this.onClickBlock(i, j)} />
          ))}

        </svg>

        {hasMoved &&
          <div style={{width: 240, height: 200}} />
        }
      </div>
    )
  }

}


function getColor(i, j) {
  const colors = ['red', 'green', 'blue', 'yellow', 'black', 'purple', 'orange', 'teal']

  if (
    (i == 5 && j == 1) ||
    (i == 9 && j == 1) ||
    (i == 9 && j == 2) ||
    (i == 17 && j == 4)
  ) {
    return 'rgba(0, 0, 0, 0.2)'
  } else if (i == 18 && j == 1) {
    return 'pink'
  } else {
    return colors[((i + j * 793) * 13791) % colors.length]
  }
}


// WEBPACK FOOTER //
// ./src/stage/slide.tsx